<template>
  <w-card tile class="userinfo-card ml2 mr2">
    <template #title>
      <w-toolbar>
        <div class="title3" v-if='!user.authorized'>Авторизация</div>
        <div class="title3" v-else>Профиль</div>
      </w-toolbar>
    </template>
    <div v-if='!user.authorized'>
      <p>Используйте для входа корпоративную почту @edu.misis.ru.</p>
      <w-flex grow justify-space-evenly class="mt3">
        <template v-for="link in authLinks" v-bind:key="link.icon">
          <a v-bind:href='link.url'>
            <w-button color="primary" outline>
              <font-awesome-icon :icon=link.icon class="mr2"/>
              {{ link.name }}
            </w-button>
          </a>
        </template>
      </w-flex>
    </div>
    <div v-else>
      <div>
        <p>ФИО: {{ user.name }}</p>
        <p>Почта: {{ user.email }}</p>
        <p v-if="user.telegram">Telegram привязан.</p>

      </div>
      <div v-if="!user.telegram" class="mt3">
        <a v-bind:href='user.telegramUrl'>
          <w-button color="primary" outline>
            <font-awesome-icon :icon='["fab", "telegram"]' class="mr2"/>
            Привязать Telegram
          </w-button>
        </a>

      </div>
    </div>
  </w-card>
  <w-flex grow justify-center class="mt3">
    <a href="/logout" v-if="user.authorized">
      <w-button color="primary" outline>
        <font-awesome-icon icon="sign-out-alt" class="mr2"/>
        Выйти
      </w-button>
    </a>
  </w-flex>
</template>

<script>
import { useRoute } from 'vue-router'

export default {
  name: 'UserInfo',
  components: {
  },
  props: {
    user: Object
  },
  data: function () {
    return {
      authLinks: [
        {icon: ['fab', 'google'], name: 'Google', url: 'https://accounts.google.com/o/oauth2/v2/auth?client_id=1014653424919-gg4umde08shal63n7ockhclic0bs68q6.apps.googleusercontent.com&redirect_uri=https://account.misis.club/google&response_type=code&scope=openid%20profile%20email&prompt=consent'},
        {icon: ['fab', 'microsoft'], name: 'Microsoft', url: 'https://login.microsoftonline.com/administratormisis.onmicrosoft.com/oauth2/v2.0/authorize?client_id=e3dc1bdd-a346-420d-9f30-3ccaeb70c080&scope=openid%20email%20profile&response_type=token&prompt=select_account&domain_hint=edu.misis.ru&lc=25'}
      ]
    }
  },
  async setup(props){
    var route = useRoute()
    if (!route.query.return) {
      localStorage.return = 'https://misis.club';
    }
    else {
      localStorage.return = route.query.return;
    }
  }
}
</script>

<style>
.userinfo-card {
  min-width: 350px;
}
</style>
